import { cn } from '@/lib/utils';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomTab from '@/widget/CustomTab';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';
import { useHoldingData } from '../../hooks/useHoldingData';
import useTransferHistoryList from '../../hooks/useTransferHistoryList';
import { useActivityList } from '../../hooks/useActivityList';
import Holding from '../Holding';
import Activity from '../Activity';
import History from '../History';
import AccountInfo from '../AccountInfo';
import HandleFunds from '../HandleFunds';
import { useAppStore } from '@/store';
import { useAppEventBusContext } from '@/context/eventBusContext';
import { SubscribeEvent } from '@/interface/event';
export default () => {
  const { fwClass, chainInfo } = useAppStore();
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const { publish } = useAppEventBusContext();
  const swiperRef = useRef<SwiperType | null>(null);

  const tabs = [t('Account.holding'), t('Account.activity'), ...(chainInfo.chain == 'solana' ? [t('Account.history')] : [])];
  useEffect(() => {
    if (swiperRef.current && swiperRef.current.activeIndex !== activeIndex) {
      swiperRef.current.slideTo(activeIndex);
    }
  }, [activeIndex]);

  useEffect(() => {
    publish(SubscribeEvent.Update_Balance);
  }, []);

  const { loading, holdingList } = useHoldingData();
  const { loading: activityLoading, activityList, tradeType, setTradeType } = useActivityList();
  const { loading: historyLoading, transferMap } = useTransferHistoryList();

  return (
    <div className="px-[16px] mb-[70px]">
      <AccountInfo />
      <HandleFunds />
      <CustomTab tabs={tabs} wrapperClassName={cn(fwClass, 'gap-x-[16px] mb-[16px]')} activeIndex={activeIndex} onTabChange={setActiveIndex} />
      <Swiper
        className="w-full h-full"
        initialSlide={activeIndex}
        onSlideChange={(e) => setActiveIndex(e.activeIndex)}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
      >
        <SwiperSlide>{activeIndex == 0 && <Holding loading={loading} holdingList={holdingList} />}</SwiperSlide>
        <SwiperSlide>
          {activeIndex == 1 && <Activity loading={activityLoading} activityList={activityList} tradeType={tradeType} setTradeType={setTradeType} />}
        </SwiperSlide>
        {tabs.length > 2 && <SwiperSlide>{activeIndex == 2 && <History loading={historyLoading} transferMap={transferMap} />}</SwiperSlide>}
      </Swiper>
    </div>
  );
};
